import { render } from "./CustomVueSelect.vue?vue&type=template&id=8fe415e2&scoped=true"
import script from "./CustomVueSelect.vue?vue&type=script&lang=js"
export * from "./CustomVueSelect.vue?vue&type=script&lang=js"

import "./CustomVueSelect.vue?vue&type=style&index=0&id=8fe415e2&lang=scss&scoped=true"

import exportComponent from "/var/www/recruitment-form-front-end-master/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fe415e2"]])

export default __exports__